export default __webpack_public_path__ + "static/media/card2.fbf56d86.png";